import { Injectable } from '@angular/core';
import { AuthService } from '../../auth.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { User } from './user';
import { SuccessResponse } from '../appointment/success.response';
import { Permissions } from './permissions';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private http: HttpClient, private auth: AuthService) { }

  getUsers(): Observable<User[]> {
    return this.http.get<User[]>('/api/users')
    .pipe(map(response => {
      return response
    }))
  }

  getPermissions(): Observable<Permissions[]> {
    return this.http.get<Permissions[]>('/api/permissions')
    .pipe(map(response => {
      console.log(response)
      return response
    }))
  }

  addUser(user: User): Observable<SuccessResponse> {
    const baseHeaders = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
    const data = `firstName=${user.firstName}` +
    `&lastName=${user.lastName}` +
    `&email=${user.email}` +
    `&phone=${user.phoneNumber}`
    return this.http.post<SuccessResponse>('/api/users', data, { headers: baseHeaders })
    .pipe(map(response => {
      return response
    }))
  }

  updateUserInformation(user: User): Observable<SuccessResponse> {
    const baseHeaders = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
    const data =`firstName=${user.firstName}` +
    `&lastName=${user.lastName}` +
    `&email=${user.email}` +
    `&phone=${user.phoneNumber}`
    return this.http.patch<SuccessResponse>(`/api/users/${user.id}`, data, { headers: baseHeaders })
    .pipe(map(response => {
      return response
    }))
  }

  updateUserPermissions(userId: number, permissions: Permissions[]): Observable<SuccessResponse> {
    const baseHeaders = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');

    const addPermissions = permissions.filter((permission) => permission.userPermissionId === true).map((permission) => permission.permissionId)
    const removePermissions = permissions.filter((permission) => permission.userPermissionId === false).map((permission) => permission.permissionId)
    const data = { 
      addPermissionArr: addPermissions,
      removePermissionArr: removePermissions
    }

    return this.http.post<SuccessResponse>(`/api/users/${userId}/permissions`, $.param(data), { headers: baseHeaders })
    .pipe(map(response => {
      return response
    }))
  }
}
